import React from 'react';
import {
    Box,
    Typography,
    Button,
    Dialog
} from '@mui/material';
import { CheckCircle as CheckCircleIcon } from '@mui/icons-material';
import './SuccessModal.css';

const SuccessModal = ({ open, onOkay }) => {
    return (
        <Dialog
            open={open}
            onClose={() => { }}
            PaperProps={{
                className: 'success-modal-paper'
            }}
        >
            {/* Header Section: Dark Navy */}
            <Box className="success-modal-header">
                <CheckCircleIcon className="success-modal-icon" />
                <Typography className="success-modal-title">
                    Policy acknowledged successfully.
                </Typography>
            </Box>

            {/* Footer Section: White */}
            <Box className="success-modal-footer">
                <Button
                    variant="contained"
                    size="small"
                    onClick={onOkay}
                    className="success-modal-button"
                >
                    Okay
                </Button>
            </Box>
        </Dialog>
    );
};

export default SuccessModal;
